export default "__VITE_ASSET__VTT_Rnj0__"